import React from 'react';
import { Tooltip, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import { TimeSignal } from 'graphql/types';
import { useMessage } from 'modules/intl';

interface StyleProps {
  isItemGrouped?: boolean;
  isItemInTimeline?: boolean;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: theme.spacing(7),
    margin: ({ isItemGrouped, isItemInTimeline }: StyleProps) =>
      isItemGrouped
        ? theme.spacing(0, 0, 0, 2)
        : isItemInTimeline
        ? theme.spacing(0.5, 2)
        : theme.spacing(0.125, 0.25, 0.75, 2),
    display: 'flex',
    justifyContent: 'right',
    alignItems: 'center',
    opacity: 1
  },
  label: {
    padding: theme.spacing(0, 0.75),
    color: theme.palette.grey[800],
    borderRadius: theme.spacing(0.25)
  },
  excluded: {
    background: theme.palette.excluded.background,
    color: theme.palette.excluded.contrastText
  }
}));

type ExcludedTagProps = {
  note: TimeSignal;
  isItemGrouped?: boolean;
  isItemInTimeline?: boolean;
};

export const ExcludedTag: React.FC<ExcludedTagProps> = ({
  note,
  isItemGrouped,
  isItemInTimeline
}: ExcludedTagProps) => {
  const classes = useStyles({
    isItemGrouped,
    isItemInTimeline
  });
  const tooltipMessage = useMessage('excluded.tooltip') || '';
  return (
    <Tooltip
      title={tooltipMessage}
      data-testid={`excluded-tag-tooltip-${note.id}`}
    >
      <div data-testid={`excluded-tag-${note.id}`} className={classes.root}>
        <Typography
          className={classnames(classes.label, classes.excluded)}
          variant="caption"
        >
          <FormattedMessage id={'notes.excluded'} />
        </Typography>
      </div>
    </Tooltip>
  );
};
